import { intelligentCaptions, LovedCaptions, attitudeCaptions, suggestedCaptions, tagIntentMap, coffeeCaptions, interiorCaptions, generalCaptions, natureCaptions } from "./SuggestedCaptions";

const recentCaptionsMap = new Map();
const captionCache = new Map();

function getRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}


// function detectIntentFromTags(tags) {
//   if (!tags) return null;

//   const tagList = tags.toLowerCase().split(",");

//   for (const tag of tagList) {
//     const cleanTag = tag.trim();

//     if (tagIntentMap.love.includes(cleanTag)) {
//       return "love";
//     }

//     if (tagIntentMap.attitude.includes(cleanTag)) {
//       return "attitude";
//     }

//     if (tagIntentMap.general.includes(cleanTag)) {
//       return "general";
//     }
//   }

//   return null;
// }

function matchesTag(list, tag) {
  if(!list) return 

  return list.some(item => tag.includes(item));
}


function detectIntentFromTags(tags) {
  if (!tags) return null;

  const tagList = tags.toLowerCase().split(",");

  let score = { love: 0, attitude: 0, general: 0, nature: 0 };

  for (const tag of tagList) {
    const cleanTag = tag.trim();

    // if (tagIntentMap.love.includes(cleanTag)) score.love++;
    // if (tagIntentMap.attitude.includes(cleanTag)) score.attitude++;
    // if (tagIntentMap.general.includes(cleanTag)) score.general++;

    if (matchesTag(tagIntentMap.love, cleanTag)) score.love++;
if (matchesTag(tagIntentMap.attitude, cleanTag)) score.attitude++;
if (matchesTag(tagIntentMap.nature, cleanTag)) score.nature++;
if (matchesTag(tagIntentMap.general, cleanTag)) score.general++;
  }

  // return Object.keys(score).reduce((a, b) => score[a] > score[b] ? a : b);
//   if (score.love > 0) return "love";
// if (score.attitude > 0) return "attitude";
// if (score.nature > 0) return "nature"; 
// if (score.general > 0) return "general";
return getBestIntent(score);

return null;
}

function getBestIntent(score) {
  const entries = Object.entries(score);

  const [intent, value] = entries.reduce((best, current) => {
    return current[1] > best[1] ? current : best;
  });

  return value > 0 ? intent : null;
}


function normalizeText(value = "") {
  return value
    .toLowerCase()
    .replace(/-/g, " ")
    .replace(/[^\w\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

// function getImageSearchText(image) {
//   return normalizeText([
//     image?._category,
//     image?.tags,
//     image?.name,
//     image?.heading,
//     image?.description
//   ].filter(Boolean).join(" "));
// }

// function getIntelligentCaption(image) {
//   const imageText = ` ${getImageSearchText(image)} `;

//   const scoredCaptions = intelligentCaptions.map(caption => {
//     let score = 0;

//     (caption.keywords || []).forEach(keyword => {
//       const normalizedKeyword = normalizeText(keyword);

//       if (
//         normalizedKeyword &&
//         imageText.includes(` ${normalizedKeyword} `)
//       ) {
//         score += normalizedKeyword.split(" ").length;
//       }
//     });

//     return {
//       caption,
//       score
//     };
//   });

//   const bestScore = Math.max(
//     0,
//     ...scoredCaptions.map(item => item.score)
//   );

//   // No meaningful keyword match: use the existing library.
//   if (bestScore === 2) return null;

//   const bestMatches = scoredCaptions.filter(
//     item => item.score === bestScore
//   );

//   return getRandom(bestMatches).caption.text;
// }



// export function GetCaptionForImages(image, imageCategory = null) {

//   if (!image?._uid) return "";

//   // ✅ return cached caption
//   if (captionCache.has(image._uid)) {
//     return captionCache.get(image._uid);
//   }

//   // const category = imageCategory ||  image?._category?.toLowerCase();
//   const category = image?._category?.toLowerCase();
// console.log("category intent 1", image,  category)

//   // let pool = suggestedCaptions;
//   let pool = generalCaptions;

//   if (category?.includes("train") || category?.includes("travel")) {
//     // pool = suggestedCaptions;
//     pool =  [...generalCaptions, ...suggestedCaptions];;
//   } else if (category?.includes("nature")) {
//     pool = natureCaptions;
//     // pool =  [...generalCaptions, ...suggestedCaptions];
//   } else if (category?.includes("people")) {
//     // pool = suggestedCaptions;
//     pool =  [...generalCaptions, ...suggestedCaptions];;
//   } else if (category?.includes("interior") || category?.includes("home")) {
//   pool = interiorCaptions;
// }else if (image.tags?.includes("coffee")) {
//   pool = coffeeCaptions;

// }
//   else {
//     const intent = detectIntentFromTags(image.tags);

//     if (intent === "love") pool = LovedCaptions;
//     // else if (intent === "attitude") pool = attitudeCaptions;

//   else if (intent === "attitude") {

//     if (category?.includes("car") || category?.includes("fashion")) {
//       pool = attitudeCaptions;
//     } else {
//       pool =  [...generalCaptions, ...suggestedCaptions];;
//     }

//   }
//   else if (intent === "nature") pool = natureCaptions;
//     else if (intent === "general") pool = generalCaptions;
//   }

//   const key = category || intent || "default";

//   let recent = recentCaptionsMap.get(key) || [];

//   const available = pool.filter(c => !recent.includes(c));
//   const finalPool = available.length ? available : pool;

//   // const caption = getRandom(finalPool);
//   // const caption = finalPool[Math.floor(Math.random() * Math.min(4, finalPool.length))];
//   // const caption = getRandom(finalPool);
//    const caption = selectBestCaption(
//     pool,
//     context,
//     intent,
//     recent
//   );

//   // store recent
//   recent.push(caption);
//   if (recent.length > 5) recent.shift();
//   recentCaptionsMap.set(key, recent);

//   // 🔥 store stable caption
//   captionCache.set(image._uid, caption);

//   return caption;
// }



function normalizeTexts(value = "") {
  return value
    .toLowerCase()
    .replace(/-/g, " ")
    .replace(/[^\w\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}


function containsPhrase(source, keyword) {
  const text = ` ${normalizeTexts(source)} `;
  const phrase = ` ${normalizeTexts(keyword)} `;

  return text.includes(phrase);
}

function getIntelligentCaption(image, detectedIntent) {
  const sources = {
    category: image?._category || "",
    tags: image?.tags || "",
    name: image?.name || "",
    description: [
      image?.heading,
      image?.description
    ].filter(Boolean).join(" ")
  };

  const weights = {
    category: 5,
    tags: 3,
    name: 2,
    description: 1
  };

  const scoredCaptions = intelligentCaptions.map(caption => {
    let score = 0;
    const matchedKeywords = [];

    (caption.keywords || []).forEach(keyword => {
      let keywordScore = 0;

      Object.entries(sources).forEach(([source, value]) => {
        if (containsPhrase(value, keyword)) {
          keywordScore = Math.max(
            keywordScore,
            weights[source]
          );
        }
      });

      if (keywordScore > 0) {
        score += keywordScore;
        matchedKeywords.push(keyword);
      }
    });

    // A broad intent match is supporting evidence,
    // not enough by itself to select a caption.
    if (
      caption.intent &&
      detectedIntent &&
      caption.intent === detectedIntent
    ) {
      score += 2;
    }

    return {
      caption,
      score,
      matchedKeywords
    };
  });

  const bestScore = Math.max(
    0,
    ...scoredCaptions.map(item => item.score)
  );

  // Do not select a caption based only on broad intent.
  if (bestScore < 3) {
    return null;
  }

  const bestMatches = scoredCaptions.filter(
    item => item.score === bestScore
  );

  const selected = getRandom(bestMatches);

  console.log("Intelligent caption matching:", {
    category: sources.category,
    detectedIntent,
    selectedCaption: selected.caption.text,
    score: selected.score,
    matchedKeywords: selected.matchedKeywords
  });

  return selected.caption.text;
}


export function GetCaptionForImages(image, imageCategory = null) {
  if (!image?._uid) return "";

  if (captionCache.has(image._uid)) {
    return captionCache.get(image._uid);
  }

  const category = (
    imageCategory || image?._category || ""
  ).toLowerCase();

  const intent = detectIntentFromTags(image.tags);

  // 1. Try the intelligent caption library first.
  const intelligentCaption = getIntelligentCaption(image, intent);

  if (intelligentCaption) {
    captionCache.set(image._uid, intelligentCaption);
    return intelligentCaption;
  }

  // 2. No intelligent match: use the existing caption library.
  let pool = generalCaptions;

  if (
    category.includes("train") ||
    category.includes("travel")
  ) {
    pool = [...generalCaptions, ...suggestedCaptions];

  } else if (category.includes("nature")) {
    pool = natureCaptions;

  } else if (category.includes("people")) {
    pool = [...generalCaptions, ...suggestedCaptions];

  } else if (
    category.includes("interior") ||
    category.includes("home")
  ) {
    pool = interiorCaptions;

  } else if (
    normalizeText(image.tags).includes("coffee")
  ) {
    pool = coffeeCaptions;

  } else if (intent === "love") {
    pool = LovedCaptions;

  } else if (intent === "attitude") {
    pool = attitudeCaptions;

  } else if (intent === "nature") {
    pool = natureCaptions;

  } else if (intent === "general") {
    pool = generalCaptions;
  }

  // 3. Support both string captions and object captions.
  const recentKey = category || intent || "default";
  const recent = recentCaptionsMap.get(recentKey) || [];

  const available = pool.filter(caption => {
    const text = typeof caption === "string"
      ? caption
      : caption.text;

    return text && !recent.includes(text);
  });

  const finalPool = available.length ? available : pool;

  const selectedCaption = getRandom(finalPool);

  const caption = typeof selectedCaption === "string"
    ? selectedCaption
    : selectedCaption?.text || "";

  // 4. Store recent captions.
  recent.push(caption);

  if (recent.length > 5) {
    recent.shift();
  }

  recentCaptionsMap.set(recentKey, recent);

  captionCache.set(image._uid, caption);

  return caption;
}


export function getPostData(image, imageCategory = null, componentFrom = null) {
  console.log("for  home to explorenext")
  // if (!image?._uid) return null;


  console.log("for  home to explorenext", image)

  // if (captionCache.has(image._uid)) {
  //   return captionCache.get(image._uid);
  // }

  // 🔥 1. Caption (reuse your existing logic)
  const captions = GetCaptionForImages(image, imageCategory);

  // 🔥 2. Hashtags (dynamic based on category + tags)
  const category = image?._category?.toLowerCase();

  let hashtags = ["#explorepage", "#instagood", "#viralposts"];

  

  if (category?.includes("nature")) {
    hashtags.push("#naturelovers", "#greenvibes", "#earthfocus");
  } else if (category?.includes("travel")) {
    hashtags.push("#wanderlust", "#travelgram", "#exploremore");
  } else if (category?.includes("fashion")) {
    hashtags.push("#styleinspo", "#ootd", "#fashiongram");
  } else {
    hashtags.push("#photooftheday", "#aesthetic");
  }

  // also include image tags (🔥 strong growth loop)
  if (image.tags) {
    const tagList = image.tags.split(",").slice(0, 3);
    hashtags.push(...tagList.map(tag => `#${tag.trim().replace(/\s+/g, "")}`));
  }

  
  // 🔥 3. Platform (based on intent / content type)
  let platform = "Instagram";
  if (category?.includes("professional") || category?.includes("business")) {
    platform = "LinkedIn";
  } else if (category?.includes("funny") || category?.includes("meme")) {
    platform = "Facebook";
  }

  // 🔥 4. Best Time (simple logic now → can improve later)
  let time = "7:30 PM";

  if (category?.includes("business")) time = "9:00 AM";
  if (category?.includes("travel")) time = "6:30 PM";

  const result = { captions, hashtags, platform, time };

  // captionCache.set(image._uid, result);

  return result;
}